module.exports = __webpack_public_path__ + "static/media/nursery_2.68423e7c.png";